<template>
    <div>
        <div class="content-caption dashed">
            <span>收货验收单信息</span>
            <div class="shrink-tab fr" :class="showPurchReceiptFlag? 'current': ''" @click="doShowPurchReceipt()">
                <span>{{ showPurchReceiptFlag ? '隐藏' : '展开' }}</span>
                <i :class="showPurchReceiptFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <template v-if="showPurchReceiptFlag">
            <div class="simple-form">
                <div class="form-group">
                    <div class="form-label">
                        <label>标题</label>
                    </div>
                    <div class="form-value">
                        <span>{{ receipt.title || '无' }}</span>
                    </div>
                </div>
            </div>
            <div class="simple-form flex col-4">
                <div class="form-group">
                    <div class="form-label">
                        <label>验收单号</label>
                    </div>
                    <div class="form-value">
                        <span>{{ receipt.innerNo || '无' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>买家公司编码</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.buyerRealComCode || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>买家公司名称</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.buyerRealComName || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>请购部门/门店</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.recvComName || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>卖家标识</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.buyerInnerSellerCode || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>卖家名称</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.sellerName || '' }}</span>
                    </div>
                </div>
            </div>
            <div class="simple-form flex col-4">
                <div class="form-group">
                    <div class="form-label">
                        <label>物流费(元)</label>
                    </div>
                    <div class="form-value">
                        <span v-if="receipt.logisFee != null">{{ parseFloat(receipt.logisFee).toFixed(2) }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>组装费(元)</label>
                    </div>
                    <div class="form-value">
                        <span v-if="receipt.asmblFee != null">{{ parseFloat(receipt.asmblFee).toFixed(2) }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>安装费(元)</label>
                    </div>
                    <div class="form-value">
                        <span v-if="receipt.setupFee != null">{{ parseFloat(receipt.setupFee).toFixed(2) }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>拆除费(元)</label>
                    </div>
                    <div class="form-value">
                        <span v-if="receipt.tearFee != null">{{ parseFloat(receipt.tearFee).toFixed(2) }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>上门费(元)</label>
                    </div>
                    <div class="form-value">
                        <span v-if="receipt.toDoorFee != null">{{ parseFloat(receipt.toDoorFee).toFixed(2) }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>维修费(元)</label>
                    </div>
                    <div class="form-value">
                        <span v-if="receipt.repairFee != null">{{ parseFloat(receipt.repairFee).toFixed(2) }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>其他杂费(元)</label>
                    </div>
                    <div class="form-value">
                        <span v-if="receipt.otherFee != null">{{ parseFloat(receipt.otherFee).toFixed(2) }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>费用总计(元)</label>
                    </div>
                    <div class="form-value">
                        <span v-if="receipt.amount != null">{{ parseFloat(receipt.amount).toFixed(2) }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>发票类型</label>
                    </div>
                    <div class="form-value">
                        <el-select v-model="receipt.invoiceType" @change="invoiceTypeChange">
                            <el-option label="增值税-普通发票" :value="1"/>
                            <el-option label="增值税-专用发票" :value="2"/>
                        </el-select>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">是否抵扣税</label>
                    </div>
                    <div class="form-value">
                        <span v-if="receipt.invoiceType == 1">否</span>
                        <el-select v-model="receipt.taxOffset" placeholder="请选择" v-else @change="changeTaxOffset">
                            <el-option label="是" :value="true"></el-option>
                            <el-option label="否" :value="false"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">税率(%)</label>
                    </div>
                    <div class="form-value">
                        <el-select v-model="receipt.taxRate" placeholder="请选择税率" @change="changeActualAmount()">
                            <el-option v-for="item in fiscalTaxMarkList" :key="item.rate" :label="item.rate" :value="item.rate"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
        </template>

        <div class="content-caption dashed">
            <span>订货验收信息</span>
            <div class="shrink-tab fr" :class="showPurchReceiptGoodsItemFlag? 'current': ''" @click="doShowPurchReceiptGoodsItem()">
                <span>{{ showPurchReceiptGoodsItemFlag ? '隐藏' : '展开' }}</span>
                <i :class="showPurchReceiptGoodsItemFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <template v-if="showPurchReceiptGoodsItemFlag">
            <div class="table-layout">
                <div v-if="receipt.goodsItemList != null && receipt.goodsItemList.length > 0">
                    <el-table ref="multipleTable" :data="receipt.goodsItemList" border tooltip-effect="dark" style="width: 100%" maxHeight="400">
                        <el-table-column align="left" prop="assetDefNo" label="资产定义编码" width="150" fixed show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" prop="assetDefName" label="资产定义名称" fixed show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" prop="assetNature" label="资产属性" width="150" fixed show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ assetNatureMap[rows.row.assetNature] }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="quantity" label="验收数量" width="150" fixed show-overflow-tooltip></el-table-column>
                        <el-table-column align="right" prop="innerCode" label="含税单价(元)" width="150" fixed show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span v-if="rows.row.wtxPrice != null">{{ rows.row.wtxPrice }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="innerCode" label="税率(%)" width="150" fixed show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ parseFloat(rows.row.taxRate).toFixed(2) || 0.00 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="ntxPrice" label="未税单价(元)" width="150" fixed show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span v-if="rows.row.ntxPrice != null">{{ parseFloat(rows.row.ntxPrice).toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="innerCode" label="含税总金额(元)" width="150" fixed show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span v-if="rows.row.wtxAmount != null">{{ parseFloat(rows.row.wtxAmount).toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="innerCode" label="未税总金额(元)" width="150" fixed show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span v-if="rows.row.ntxAmount != null">{{ parseFloat(rows.row.ntxAmount).toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="innerCode" label="税额小计(元)" width="150" fixed show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span v-if="rows.row.taxAmount != null">{{ parseFloat(rows.row.taxAmount).toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </template>


        <div class="content-caption dashed">
            <span>费用</span>
            <div class="shrink-tab fr" :class="showPurchReceiptFeeFlag? 'current': ''" @click="doShowPurchReceiptFee()">
                <span>{{ showPurchReceiptFeeFlag ? '隐藏' : '展开' }}</span>
                <i :class="showPurchReceiptFeeFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <template v-if="showPurchReceiptFeeFlag">
            <div class="simple-row">
                <div class="left" v-if="(purchFeeNames || []).length > 0">
                    <div class="fl mr30" v-if="purchFeeNames.contains('LogisFee')">
                        <label class="mr5">物流费总计(元)</label>
                        <span>{{ logisFee }}</span>
                    </div>
                    <div class="fl mr30" v-if="purchFeeNames.contains('AsmblFee')">
                        <label class="mr5">组装费总计(元)</label>
                        <span>{{ asmblFee }}</span>
                    </div>
                    <div class="fl mr30" v-if="purchFeeNames.contains('SetupFee')">
                        <label class="mr5">安装费总计(元)</label>
                        <span>{{ setupFee }}</span>
                    </div>
                    <div class="fl mr30" v-if="purchFeeNames.contains('TearFee')">
                        <label class="mr5">拆除费总计(元)</label>
                        <span>{{ tearFee }}</span>
                    </div>
                    <div class="fl mr30" v-if="purchFeeNames.contains('toDoorFee')">
                        <label class="mr5">上门费总计(元)</label>
                        <span>{{ toDoorFee }}</span>
                    </div>
                    <div class="fl mr30" v-if="purchFeeNames.contains('RepairFee')">
                        <label class="mr5">维修费总计(元)</label>
                        <span>{{ repairFee }}</span>
                    </div>
                    <div class="fl mr30" v-if="purchFeeNames.contains('OthersFee')">
                        <label class="mr5">其他杂费总计(元)</label>
                        <span>{{ otherFee }}</span>
                    </div>
                </div>
                <div class="right">
                    <a class="swb-btn swb-btn-small" @click="selectFees()" v-if="receipt.contractId != null && receipt.contractId != -1">选择</a>
                    <a class="swb-btn swb-btn-small" @click="addFees()">新增</a>
                </div>
            </div>
            <el-table ref="multipleTable" :data="receipt.feeItemList" border tooltip-effect="dark" style="width: 100%" maxHeight="400" :summary-method="getFeeItemSum" show-summary>
                <el-table-column align="center" prop="feeType" label="费用类型" width="150" fixed show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span>{{ purchFeeTypeMap[rows.row.feeType] }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" prop="name" label="名称" fixed show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="brandName" label="品牌" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="modelSpec" label="规格" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="unit" width="60" label="单位"></el-table-column>
                <el-table-column prop="price" align="right" width="120" label="单价(元)">
                    <template slot-scope="rows">
                        <span v-if="rows.row.price != null">{{ rows.row.price.toFixed(2) }}</span>
                        <span v-else>0.00</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="quantity" width="120" label="数量">
                    <template slot-scope="rows">
                        <input class="align-right" type="number" v-model="rows.row.quantity" @change="quantityChange(rows.row, rows.$index)" size="6" :min="0" :max="100000" style="width: 90px"/>
                    </template>
                </el-table-column>
                <el-table-column prop="amount" align="right" width="120" label="小计(元)">
                    <template slot-scope="rows">
                        <span v-if="rows.row.amount != null">{{ parseFloat(rows.row.amount).toFixed(2) }}</span>
                        <span v-else>0.00</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" label="操作" width="170">
                    <template slot-scope="rows">
                        <a class="swb-btn-link" @click="addFees(rows.row, rows.$index)" v-if="rows.row.feeItemId == null">编辑</a>
                        <a class="swb-btn-link" @click="removeFeeItem(rows.$index)">移除</a>
                        <a class="swb-btn-link" @click="doCountFeeShare('logis', rows.row.amount)" v-if="rows.row.feeType == 1">计算分摊</a>
                        <a class="swb-btn-link" @click="doCountFeeShare('asmbl', rows.row.amount)" v-else-if="rows.row.feeType == 2">计算分摊</a>
                        <a class="swb-btn-link" @click="doCountFeeShare('setup', rows.row.amount)" v-else-if="rows.row.feeType == 3">计算分摊</a>
                        <a class="swb-btn-link" @click="doCountFeeShare('tear', rows.row.amount)" v-else-if="rows.row.feeType == 4">计算分摊</a>
                        <a class="swb-btn-link" @click="doCountFeeShare('toDoor', rows.row.amount)" v-else-if="rows.row.feeType == 5">计算分摊</a>
                        <a class="swb-btn-link" @click="doCountFeeShare('repair', rows.row.amount)" v-else-if="rows.row.feeType == 6">计算分摊</a>
                        <a class="swb-btn-link" @click="doCountFeeShare('other', rows.row.amount)" v-else-if="rows.row.feeType == 9">计算分摊</a>
                    </template>
                </el-table-column>
            </el-table>
        </template>

        <div class="content-caption dashed">
            <span>临采验收条目</span>
            <div class="shrink-tab fr" :class="showPurchReceiptItemFlag? 'current': ''" @click="doShowPurchReceiptItem()">
                <span>{{ showPurchReceiptItemFlag ? '隐藏' : '展开' }}</span>
                <i :class="showPurchReceiptItemFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <template v-if="showPurchReceiptItemFlag">
            <div class="simple-form small-form flex col-4 label" v-if="(purchFeeNames || []).length > 0">
                <div class="form-group center" v-if="purchFeeNames.contains('LogisFee')">
                    <div class="form-label">
                        <label>物流费(元)</label>
                    </div>
                    <div class="form-value">
<!--                        <el-input class="width-1x" type="number" size="4" v-model="logisFee" @change="sumXtraFeeChange(false, 'logis')"></el-input>-->
                        <span>{{ logisFee }}</span>
                        <a class="swb-btn swb-btn-small" @click="doCountFeeShare('logis', logisFee)">
                            <span>计算分摊</span>
                        </a>
                    </div>
                </div>
                <div class="form-group center" v-if="purchFeeNames.contains('AsmblFee')">
                    <div class="form-label">
                        <label>组装费(元)</label>
                    </div>
                    <div class="form-value">
<!--                        <el-input class="width-1x" type="number" size="4" v-model="asmblFee" @change="sumXtraFeeChange(false, 'asmbl')"></el-input>-->
                        <span>{{ asmblFee }}</span>
                        <a class="swb-btn swb-btn-small" @click="doCountFeeShare('asmbl', asmblFee)">
                            <span>计算分摊</span>
                        </a>
                    </div>
                </div>
                <div class="form-group center" v-if="purchFeeNames.contains('SetupFee')">
                    <div class="form-label">
                        <label>安装费(元)</label>
                    </div>
                    <div class="form-value">
<!--                        <el-input class="width-1x" type="number" size="4" v-model="setupFee" @change="sumXtraFeeChange(false, 'setup')"></el-input>-->
                        <span>{{ setupFee }}</span>
                        <a class="swb-btn swb-btn-small" @click="doCountFeeShare('setup', setupFee)">
                            <span>计算分摊</span>
                        </a>
                    </div>
                </div>
                <div class="form-group center" v-if="purchFeeNames.contains('TearFee')">
                    <div class="form-label">
                        <label>拆除费(元)</label>
                    </div>
                    <div class="form-value">
<!--                        <el-input class="width-1x" type="number" size="4" v-model="tearFee" @change="sumXtraFeeChange(false, 'tear')"></el-input>-->
                        <span>{{ tearFee }}</span>
                        <a class="swb-btn swb-btn-small" @click="doCountFeeShare('tear', tearFee)">
                            <span>计算分摊</span>
                        </a>
                    </div>
                </div>
                <div class="form-group center" v-if="purchFeeNames.contains('toDoorFee')">
                    <div class="form-label">
                        <label>上门费(元)</label>
                    </div>
                    <div class="form-value">
<!--                        <el-input class="width-1x" type="number" size="4" v-model="toDoorFee" @change="sumXtraFeeChange(false, 'toDoor')"></el-input>-->
                        <span>{{ toDoorFee }}</span>
                        <a class="swb-btn swb-btn-small" @click="doCountFeeShare('toDoor', toDoorFee)">
                            <span>计算分摊</span>
                        </a>
                    </div>
                </div>
                <div class="form-group center" v-if="purchFeeNames.contains('RepairFee')">
                    <div class="form-label">
                        <label>维修费(元)</label>
                    </div>
                    <div class="form-value">
<!--                        <el-input class="width-1x" type="number" size="4" v-model="repairFee" @change="sumXtraFeeChange(false, 'repair')"></el-input>-->
                        <span>{{ repairFee }}</span>
                        <a class="swb-btn swb-btn-small" @click="doCountFeeShare('repair', repairFee)">
                            <span>计算分摊</span>
                        </a>
                    </div>
                </div>
                <div class="form-group center" v-if="purchFeeNames.contains('OthersFee')">
                    <div class="form-label">
                        <label>其他杂费(元)</label>
                    </div>
                    <div class="form-value">
<!--                        <el-input class="width-1x" type="number" size="4" v-model="otherFee" @change="sumXtraFeeChange(false, 'other')"></el-input>-->
                        <span>{{ otherFee }}</span>
                        <a class="swb-btn swb-btn-small" @click="doCountFeeShare('other', otherFee)">
                            <span>计算分摊</span>
                        </a>
                    </div>
                </div>
<!--                <div class="form-group center">-->
<!--                    <div class="form-label">-->
<!--                        <label>分摊总计(元)</label>-->
<!--                    </div>-->
<!--                    <div class="form-value">-->
<!--                        <span>{{ (xtraFee || 0).toFixed(2) }}</span>-->
<!--                    </div>-->
<!--                </div>-->
            </div>
            <div class="table-layout">
                <div v-if="receipt.itemList != null && receipt.itemList.length > 0">
                    <el-table ref="multipleTable" :data="receipt.itemList" border tooltip-effect="dark" :summary-method="getDetailItemSum" show-summary style="width: 100%" maxHeight="400" @selection-change="handleSelectionChange">
                        <el-table-column align="center" type="selection" :selectable="selectable" width="55"></el-table-column>
                        <el-table-column align="left" prop="devcDefNo" label="资产定义编码" width="150" fixed show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" prop="innerCode" label="资产编号" width="150" fixed show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" prop="goodsTitle" label="资产名称" width="200" fixed show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" prop="tmpNo" label="系统编号" width="220" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" prop="assetNature" label="资产属性" width="150" fixed show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ assetNatureMap[rows.row.assetNature] }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" prop="catName" label="资产分类" width="120" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" prop="brandName" label="资产品牌" width="120" show-overflow-tooltip></el-table-column>
                        <el-table-column align="right" prop="quantity" width="80" label="数量"></el-table-column>
                        <el-table-column align="center" prop="theUnit" min-width="50" label="单位"></el-table-column>
                        <el-table-column align="right" prop="xtraFee" label="分摊费用总计(元)" width="140">
                            <template slot-scope="rows">
                                <span v-if="rows.row.xtraFee != null">{{ parseFloat(rows.row.xtraFee).toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="logisPrice" label="物流费(元)" width="90" v-if="purchFeeNames.contains('LogisFee')">
                            <template slot-scope="rows">
                                <span v-if="rows.row.logisPrice != null">{{ parseFloat(rows.row.logisPrice).toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="asmblPrice" label="组装费(元)" width="90" v-if="purchFeeNames.contains('AsmblFee')">
                            <template slot-scope="rows">
                                <span v-if="rows.row.asmblPrice != null">{{ parseFloat(rows.row.asmblPrice).toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="setupPrice" label="安装费(元)" width="90" v-if="purchFeeNames.contains('SetupFee')">
                            <template slot-scope="rows">
                                <span v-if="rows.row.setupPrice != null">{{ parseFloat(rows.row.setupPrice).toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="tearPrice" label="拆除费(元)" width="90" v-if="purchFeeNames.contains('TearFee')">
                            <template slot-scope="rows">
                                <span v-if="rows.row.tearPrice != null">{{ parseFloat(rows.row.tearPrice).toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="toDoorPrice" label="上门费(元)" width="90" v-if="purchFeeNames.contains('toDoorFee')">
                            <template slot-scope="rows">
                                <span v-if="rows.row.toDoorPrice != null">{{ parseFloat(rows.row.toDoorPrice).toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="repairPrice" label="维修费(元)" width="90" v-if="purchFeeNames.contains('RepairFee')">
                            <template slot-scope="rows">
                                <span v-if="rows.row.repairPrice != null">{{ parseFloat(rows.row.repairPrice).toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="otherPrice" label="其他费(元)" width="90" v-if="purchFeeNames.contains('OthersFee')">
                            <template slot-scope="rows">
                                <span v-if="rows.row.otherPrice != null">{{ parseFloat(rows.row.otherPrice).toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="wtxPrice" align="right" width="120" label="含税单价(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.wtxPrice != null">{{ parseFloat(rows.row.wtxPrice).toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="taxRate" align="right" width="60" label="税率(%)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.taxRate != null">{{ parseFloat(rows.row.taxRate).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ntxPrice" align="right" width="120" label="未税单价(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.ntxPrice != null">{{ parseFloat(rows.row.ntxPrice).toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="wtxAmount" width="100" label="含税小计(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.wtxAmount != null">{{ parseFloat(rows.row.wtxAmount).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="ntxAmount" width="120" label="未税小计(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.ntxAmount != null">{{ parseFloat(rows.row.ntxAmount).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="taxAmount" width="80" label="税额小计(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.taxAmount != null">{{ parseFloat(rows.row.taxAmount).toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" prop="assetType" label="管理方式" width="60" fixed show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span v-if='rows.row.assetType == 0'>单品式</span>
                                <span v-if='rows.row.assetType == 1'>批量式</span>
                                <span v-if='rows.row.assetType == 3'>组装件</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { Vue, MsgBox, Routes } from '../../app.vues'
import { showFeeShareCalcDlg } from '../comn/dialog'
import { openContractFeeItemListDlg } from '../contract/dialog'
import { getMerchantBizParam } from '../asset/assetMain'

import merchtComnApi from '../../api/merchtComn'
import receiptApi from '../../api/receipt'
import fiscalBizApi from '../../api/fiscalBiz'

import SwbPropEditor from '../ctrl/PropEditor';

Vue.regist(SwbPropEditor);

export default {
    name: 'swb-purch-receipt-tmp-audit',
    desc: '验收单-审核',
    props: ['purchReceipt'],
    data: function () {
        return {
            receipt: {
                itemList: [],
                feeItemList: [],
                taxRate: null
            },
            invoiceStateMap: getEnumMap('invoiceState', 'value2text'),
            invoiceTypeMap: getEnumMap('invoiceType', 'value2text'),
            purchFeeTypeMap: getEnumMap('purchFeeType', 'value2text'),
            purchFeeNames: [],
            logisFee: '0.00',
            logisFeeCalFlag: false,
            asmblFee: '0.00',
            asmblFeeCalFlag: false,
            setupFee: '0.00',
            setupFeeCalFlag: false,
            tearFee: '0.00',
            tearFeeCalFlag: false,
            toDoorFee: '0.00',
            toDoorFeeCalFlag: false,
            repairFee: '0.00',
            repairFeeCalFlag: false,
            otherFee: '0.00',
            otherFeeCalFlag: false,
            xtraFee: 0, // 分摊总计
            multipleSelection: [],
            wranMsg: '存在金额拆分，请选择以下方式之一操作：\n1.重新计算分摊\n2.根据条目汇总到费用总额',
            showPurchReceiptFlag: true,
            showPurchReceiptFeeFlag: true,
            showPurchReceiptItemFlag: true,
            showPurchReceiptGoodsItemFlag: true,
            fiscalTaxMarkList: [],
            normalFlag: false,
            assetNatureMap: getEnumMap('assetNature', 'value2text'),
        }
    },
    created: function () {
        this.initData();
    },
    methods: {
        // 隐藏、展开
        doShowPurchReceipt: function () {
            this.showPurchReceiptFlag = !this.showPurchReceiptFlag;
        },
        // 隐藏、展开
        doShowPurchReceiptFee: function () {
            this.showPurchReceiptFeeFlag = !this.showPurchReceiptFeeFlag;
        },
        // 隐藏、展开
        doShowPurchReceiptItem: function () {
            this.showPurchReceiptItemFlag = !this.showPurchReceiptItemFlag;
        },
        doShowPurchReceiptGoodsItem: function () {
            this.showPurchReceiptGoodsItemFlag = !this.showPurchReceiptGoodsItemFlag;
        },
        selectable: function (row, index) {     // 回显禁用
            if(row.assetType == 3) {
                return false;
            } else {
                return true;
            }
        },
        initData() {
            let self = this;
            let receipt = Utils.merge({}, this.purchReceipt);
            let itemList = receipt.itemList || [];
            itemList.forEach(function (item) {
                item.srcInitWtxPrice = item.initWtxPrice;
                item.srcEnterQuantity = item.enterQuantity;
                //
                item.preInitWtxPrice = item.initWtxPrice;
                item.preEnterQuantity = item.enterQuantity;
            });
            receipt.taxRate = receipt.taxRate.toFixed(2);
            this.receipt = Utils.merge({}, receipt);
            //
            this.getPurchReceiptMaxPrice();
            this.getPurchReceiptDetail(function () {

            });
            this.getFiscalTaxMarkList(function () {
            });
        },
        // 获取进项税列表
        getFiscalTaxMarkList: function (callback) {
            let self = this;
            let postData = {};
            postData.disabled = false;
            postData.type = getEnumInfoWith('taxType', 'name', 'JXS').value;
            //
            let theLoad = MsgBox.loading();
            fiscalBizApi.getFiscalTaxMarkPageList(postData, function (result) {
                theLoad.hide();
                if(result.type === 'info') {
                    let fiscalTaxMarkList = result.data || [];
                    if(fiscalTaxMarkList.length > 0) {
                        fiscalTaxMarkList.forEach(function (item) {
                            item.rate = parseFloat(item.rate).toFixed(2)
                        })
                    }
                    //
                    self.fiscalTaxMarkList = Utils.merge([], fiscalTaxMarkList);
                    callback();
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 税率-实际金额change事件
        changeActualAmount: function () {
            let receipt = this.receipt || {};
            //
            if(Utils.isNoB(receipt.taxRate)) {
                receipt.taxRate = 0;
            }
            // 税率发生变化，条目中的税率跟着一起变
            let goodsItemList = receipt.goodsItemList || [];
            for(let i = 0, len = goodsItemList.length; i < len; i++) {
                let item = goodsItemList[i];
                item.taxRate = parseFloat(receipt.taxRate || 0).toFixed(2);
                item.ntxPrice = parseFloat((item.wtxPrice || 0) / (1 + (parseFloat(item.taxRate) * 0.01))).toFixed(2);
                item.ntxAmount = parseFloat((item.ntxPrice) * (item.quantity || 0)).toFixed(2);
                item.taxAmount = parseFloat((item.wtxAmount || 0) - parseFloat(item.ntxAmount)).toFixed(2);
            }
            let itemList = receipt.itemList || [];
            for(let i = 0, len = itemList.length; i < len; i++) {
                let item = itemList[i];
                item.taxOffset = receipt.taxOffset;
                item.taxRate = parseFloat(receipt.taxRate || 0).toFixed(2);
                item.ntxPrice = parseFloat((item.wtxPrice || 0) / (1 + (parseFloat(item.taxRate) * 0.01))).toFixed(2);
                item.ntxAmount = parseFloat((item.ntxPrice) * (item.quantity || 0)).toFixed(2);
                item.taxAmount = parseFloat((item.wtxAmount || 0) - parseFloat(item.ntxAmount)).toFixed(2);
            }
            //
            receipt.itemList = Utils.merge([], itemList);
            this.receipt = Utils.merge({}, receipt);
        },
        getPurchReceiptDetail: function (callback) {
            let self = this;
            //
            let postData = {};
            postData.id = this.receipt.id;
            let msgBoxDlg = MsgBox.loading();
            receiptApi.getPurchReceiptInfo(postData, function (result) {
                msgBoxDlg.close();
                if(result.type == 'info') {
                    let purchReceipt = result.data;
                    let feeItemList = purchReceipt.feeItemList || [];
                    if((Utils.isNoB(feeItemList) || feeItemList.length == 0) && purchReceipt.logisFee != null && parseFloat(purchReceipt.logisFee) > 0) {
                        let feeItem = {
                            feeType: getEnumInfoWith('purchFeeType', 'name', 'LogisFee').value,
                            name: '发货物流费',
                            quantity: null,
                            price: purchReceipt.logisFee,
                            unit: '元'
                        };
                        feeItem.amount = feeItem.price * ((Utils.isNoB(feeItem.quantity) || feeItem.quantity == 0) ? 1 : feeItem.quantity);
                        feeItemList.push(feeItem);
                    }
                    self.receipt.feeItemList = Utils.merge([], feeItemList);
                    self.calculateFeeItem(feeItemList);
                    getMerchantBizParam('asset.finac.enabled', function (result) {
                        self.normalFlag = Utils.isTrue(result);
                        callback();
                    }, 2, null, purchReceipt.buyerRealComId);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getPurchReceiptMaxPrice() {
            let self = this;
            receiptApi.getPurchReceiptMaxPrice(this.receipt.id, function (result) {
                if(result.type == 'info') {
                    let maxPriceList = result.data;
                    let maxPriceMap = {};
                    if(!Utils.isNoB(maxPriceList)) {
                        maxPriceList.forEach(function (item) {
                            maxPriceMap[item.id] = item.wtxPrice;
                        });
                    }
                    self.maxPriceMap = maxPriceMap;
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 计算费用总计
        getAmount: function () {
            let amount = 0;
            let receipt = this.receipt || {};
            let itemList = receipt.itemList || [];
            for(let i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                amount += parseFloat(item.wtxAmount || 0);
            }
            //
            receipt.amount = amount;
            this.receipt = Utils.merge({}, receipt);
        },
        // 选择费用项
        selectFees: function () {
            let self = this;
            let receipt = self.receipt || {};
            let feeItemList = receipt.feeItemList || [];
            let selectIds = [];
            for(let i = 0; i < feeItemList.length; i++) {
                let feeItem = feeItemList[i];
                if(feeItem != null && feeItem.feeItemId != null && feeItem.feeItemId != -1) {
                    selectIds.push(feeItem.feeItemId);
                }
            }
            openContractFeeItemListDlg({contractId: receipt.contractId, selectIds: selectIds}, function (feeList) {
                feeList = feeList || [];
                for(let i = 0; i < feeList.length; i++) {
                    let feeInfo = feeList[i];
                    let feeItem = {
                        feeItemId: feeInfo.id,
                        feeType: feeInfo.feeType,
                        name: feeInfo.name,
                        brandName: feeInfo.brandName,
                        modelSpec: feeInfo.modelSpec,
                        unit: feeInfo.unit,
                        quantity: 1,
                        price: feeInfo.price
                    };
                    feeItem.amount = feeItem.price * ((Utils.isNoB(feeItem.quantity) || feeItem.quantity == 0) ? 1 : feeItem.quantity);
                    feeItemList.push(feeItem);
                }
                //
                receipt.feeItemList = Utils.merge([], feeItemList);
                self.receipt = Utils.merge({}, receipt);
                //
                self.calculateFeeItem(feeItemList, null);
            });
        },
        // 新增费用
        addFees: function (row, index) {
            let self = this;
            let title = Utils.isNoB(row) ? '新增' : '修改';
            row = Utils.isNoB(row) ? {} : row;
            //
            let purchFeeTypeList = getEnumList('purchFeeType');
            let purchFeeTypes = [];
            for(let i = 0; i < purchFeeTypeList.length; i++) {
                let purchFeeType = purchFeeTypeList[i];
                purchFeeTypes.push({'label': purchFeeType.text, 'value': purchFeeType.value});
            }
            let theDlg = Vue.$showDialog({
                title: title + '费用信息',
                showCloseBtn: true,
                width: 600,
                height: 500,
                template: '<swb-prop-editor ref="prop_editor" :title="editorTitle" :noGrid="true" :showBtnBar="false" :width="430" :widthForLabel="120" :propList="propList" :viewMode="false" :readOnly="false"></swb-prop-editor>',
                data: {
                    editorTitle: '',
                    propList: [{
                        label: '费用类型', code: 'feeType', inputType: 'Single', value: row.feeType, valueType: 'Integer', tooltip: '', maxLength: 15,
                        required: true, dataList: purchFeeTypes, asDropdown: true, width: 300
                    }, {
                        label: '名称', code: 'name', value: row.name, valueType: 'String', tooltip: '', maxLength: 60, required: true, width: 300
                    }, {
                        label: '品牌', code: 'brandName', value: row.brandName, valueType: 'String', tooltip: '', maxLength: 30, required: true, width: 300
                    }, {
                        label: '规格', code: 'modelSpec', value: row.modelSpec, valueType: 'String', tooltip: '', maxLength: 60, required: false, width: 300
                    }, {
                        label: '单位', code: 'unit', value: row.unit, valueType: 'String', tooltip: '', maxLength: 5, required: true, width: 300
                    }, {
                        label: '单价(元)', code: 'price', inputType: 'Num', value: row.price, valueType: 'Float', tooltip: '', maxLength: 15, required: true,
                        width: 300
                    }, {
                        label: '数量',
                        code: 'quantity',
                        inputType: 'Num',
                        value: row.quantity,
                        valueType: 'Float',
                        tooltip: '',
                        maxLength: 15,
                        required: false,
                        width: 300
                    }]
                },
                okClicked: function () {
                    let propEditor = this.$refs['prop_editor'];
                    if(propEditor.validate()) {
                        let feeItem = propEditor.getPropValues();
                        feeItem.amount = feeItem.price * ((Utils.isNoB(feeItem.quantity) || feeItem.quantity == 0) ? 1 : feeItem.quantity);
                        //
                        let receipt = self.receipt || {};
                        let feeItemList = receipt.feeItemList || [];
                        if(Utils.isNoB(index)) {
                            feeItemList.push(feeItem);
                        } else {
                            //
                            feeItemList[index] = Utils.merge({}, feeItem);
                        }
                        receipt.feeItemList = Utils.merge([], feeItemList);
                        self.receipt = Utils.merge({}, receipt);
                        //
                        self.calculateFeeItem(feeItemList, feeItem.feeType);
                        return true;
                    } else {
                        return false;
                    }
                }
            });
        },
        calculateFeeItem: function (feeItemList, feeType) {
            let self = this;
            //
            let purchFeeNames = [];
            let logisFee = 0; // 物流费
            let asmblFee = 0; // 组装费
            let setupFee = 0; // 安装费
            let tearFee = 0; // 拆除费
            let toDoorFee = 0; // 上门费
            let repairFee = 0; // 维修费
            let otherFee = 0; // 其他费
            for(let i = 0; i < feeItemList.length; i++) {
                let feeItem = feeItemList[i];
                let feeName = getEnumInfoWith('purchFeeType', 'value', feeItem.feeType).name;
                if(!purchFeeNames.contains(feeName)) {
                    purchFeeNames.push(feeName);
                }
                // 费用计算
                if(feeName == 'LogisFee') {
                    logisFee += parseFloat(feeItem.amount);
                } else if(feeName == 'AsmblFee') {
                    asmblFee += parseFloat(feeItem.amount);
                } else if(feeName == 'SetupFee') {
                    setupFee += parseFloat(feeItem.amount);
                } else if(feeName == 'TearFee') {
                    tearFee += parseFloat(feeItem.amount);
                } else if(feeName == 'toDoorFee') {
                    toDoorFee += parseFloat(feeItem.amount);
                } else if(feeName == 'RepairFee') {
                    repairFee += parseFloat(feeItem.amount);
                } else if(feeName == 'OthersFee') {
                    otherFee += parseFloat(feeItem.amount);
                }
            }
            //
            self.purchFeeNames = Utils.merge([], purchFeeNames);
            //
            if(feeType != null) {
                let feeName = getEnumInfoWith('purchFeeType', 'value', feeType).name;
                if(feeName == 'LogisFee') {
                    if(logisFee != parseFloat(self.logisFee)) {
                        self.logisFeeCalFlag = false;
                    }
                    //
                    self.logisFee = parseFloat(logisFee).toFixed(2);
                }
                if(feeName == 'AsmblFee') {
                    if(asmblFee != parseFloat(self.asmblFee)) {
                        self.asmblFeeCalFlag = false;
                    }
                    //
                    self.asmblFee = parseFloat(asmblFee).toFixed(2);
                }
                if(feeName == 'SetupFee') {
                    if(setupFee != parseFloat(self.setupFee)) {
                        self.setupFeeCalFlag = false;
                    }
                    //
                    self.setupFee = parseFloat(setupFee).toFixed(2);
                }
                if(feeName == 'TearFee') {
                    if(tearFee != parseFloat(self.tearFee)) {
                        self.tearFeeCalFlag = false;
                    }
                    //
                    self.tearFee = parseFloat(tearFee).toFixed(2);
                }
                if(feeName == 'toDoorFee') {
                    if(toDoorFee != parseFloat(self.toDoorFee)) {
                        self.toDoorFeeCalFlag = false;
                    }
                    //
                    self.toDoorFee = parseFloat(toDoorFee).toFixed(2);
                }
                if(feeName == 'RepairFee') {
                    if(repairFee != parseFloat(self.repairFee)) {
                        self.repairFeeCalFlag = false;
                    }
                    //
                    self.repairFee = parseFloat(repairFee).toFixed(2);
                }
                if(feeName == 'OthersFee') {
                    if(otherFee != parseFloat(self.otherFee)) {
                        self.otherFeeCalFlag = false;
                    }
                    //
                    self.otherFee = parseFloat(otherFee).toFixed(2);
                }
            } else {
                if(logisFee != parseFloat(self.logisFee)) {
                    self.logisFeeCalFlag = false;
                }
                if(asmblFee != parseFloat(self.asmblFee)) {
                    self.asmblFeeCalFlag = false;
                }
                if(setupFee != parseFloat(self.setupFee)) {
                    self.setupFeeCalFlag = false;
                }
                if(tearFee != parseFloat(self.tearFee)) {
                    self.tearFeeCalFlag = false;
                }
                if(toDoorFee != parseFloat(self.toDoorFee)) {
                    self.toDoorFeeCalFlag = false;
                }
                if(repairFee != parseFloat(self.repairFee)) {
                    self.repairFeeCalFlag = false;
                }
                if(otherFee != parseFloat(self.otherFee)) {
                    self.otherFeeCalFlag = false;
                }
                //
                self.logisFee = parseFloat(logisFee).toFixed(2);
                self.asmblFee = parseFloat(asmblFee).toFixed(2);
                self.setupFee = parseFloat(setupFee).toFixed(2);
                self.tearFee = parseFloat(tearFee).toFixed(2);
                self.toDoorFee = parseFloat(toDoorFee).toFixed(2);
                self.repairFee = parseFloat(repairFee).toFixed(2);
                self.otherFee = parseFloat(otherFee).toFixed(2);
            }
            // 计算摊销费用总额
            self.sumXtraFeeChange(true, null);
        },
        // 移除费用项
        removeFeeItem: function (index) {
            //
            let receipt = this.receipt || {};
            let feeItemList = receipt.feeItemList || [];
            let delFeeName = null;
            let feeType = null;
            for(let i = 0; i < feeItemList.length; i++) {
                if(i == index) {
                    feeType = feeItemList[i].feeType;
                    delFeeName = getEnumInfoWith('purchFeeType', 'value', feeType).name;
                    //
                    feeItemList.splice(i, 1);
                    break;
                }
            }
            //
            receipt.feeItemList = Utils.merge([], feeItemList);
            this.receipt = Utils.merge({}, receipt);
            //
            let srcPurchFeeNames = this.purchFeeNames;
            this.calculateFeeItem(feeItemList, feeType);
            let newPurchFeeNames = this.purchFeeNames;
            //
            this.doSumAmount();
            if (srcPurchFeeNames.length != newPurchFeeNames.length) {
                // 自动分摊
                let receiptItemList = this.receipt.itemList || [];
                receiptItemList.forEach(function (receiptItemInfo) {
                    if(receipt.manualFlag && !receipt.asmblAccOnly) {
                        receiptItemInfo.wtxPrice = (receiptItemInfo.xtraFee / receiptItemInfo.quantity).toFixed(2);   // 分摊含税价
                    } else {
                        receiptItemInfo.wtxPrice = (parseFloat(receiptItemInfo.initWtxPrice) + (receiptItemInfo.xtraFee / receiptItemInfo.quantity)).toFixed(2);   // 含税价
                    }
                });
                this.changeActualAmount();
            }
        },
        // 数量变化事件
        quantityChange: function (row, index) {
            //
            let feeType = null;
            let receipt = this.receipt || {};
            let feeItemList = receipt.feeItemList || [];
            for(let i = 0; i < feeItemList.length; i++) {
                let feeItem = feeItemList[i];
                if(i == index) {
                    feeType = feeItem.feeType;
                    feeItem.amount = parseFloat(feeItem.price * ((Utils.isNoB(row.quantity) || row.quantity == 0) ? 0 : row.quantity));
                }
            }
            //
            receipt.feeItemList = Utils.merge([], feeItemList);
            this.receipt = Utils.merge({}, receipt);
            //
            this.calculateFeeItem(feeItemList, feeType);
        },
        // 计算分摊
        doCountFeeShare(shareFlag, amount) {
            let self = this;
            let selectList = this.multipleSelection;
            if(selectList == null || selectList.length <= 0) {
                MsgBox.warning('请选择要操作的数据');
                return;
            }
            //
            let shareName = shareFlag == 'logis' ? '物流费用' : shareFlag == 'asmbl' ? '组装费用' : shareFlag == 'setup' ? '安装费用' : shareFlag == 'tear' ? '拆除费用' ://
                shareFlag == 'toDoor' ? '上门费用' : shareFlag == 'repair' ? '维修费用' : '其他杂费'; //分摊费用名称
            let useForUpdate = true; //是否要要用结果进行过更新，如果用于更新则必须传递 shareAmount 和 shareItems，并且不能新增分摊条目
            let shareAmount = amount; //分摊费用总额
            let shareItems = [];
            //
            for(let i = 0; i < selectList.length; i++) {
                let row = selectList[i];
                let shareItem = {
                    ukId: row.tmpNo,
                    name: row.goodsTitle + (Utils.isNoB(row.catName) ? '' : ('/' + row.catName)) + (Utils.isNoB(row.brandName) ? '' : ('/' + row.brandName)),
                    quantity: row.quantity,
                    refPrice: parseFloat(row.initWtxPrice),
                    weight: parseFloat(row.initWtxPrice) * row.quantity,
                    price: 0,
                    amount: 0
                };
                shareItems.push(shareItem);
            }
            //
            let dlgConfig = {
                shareName: shareName,
                useForUpdate: useForUpdate,
                shareAmount: shareAmount,
                shareItems: shareItems,
                ukIdTitle: '系统编号',
                ukIdWidth: 150
            };
            //
            showFeeShareCalcDlg(dlgConfig, function (result) {
                //useForUpdate == true 可能得到此 结果 回调
                console.log(result);
                // 根据结果更新原来的分摊信息
                // 分摊项目小计
                let shareFee = result.shareAmount;
                let shareItemList = result.shareItems || [];
                let receipt = self.receipt || {};
                let receiptItemList = receipt.itemList || [];
                //
                if(shareFlag == 'logis') { // 物流
                    self.logisFee = parseFloat(shareFee || 0).toFixed(2);
                } else if(shareFlag == 'asmbl') { // 组装
                    self.asmblFee = parseFloat(shareFee || 0).toFixed(2);
                } else if(shareFlag == 'setup') { // 安装
                    self.setupFee = parseFloat(shareFee || 0).toFixed(2);
                } else if(shareFlag == 'tear') { // 拆除
                    self.tearFee = parseFloat(shareFee || 0).toFixed(2);
                } else if(shareFlag == 'toDoor') { // 上门
                    self.toDoorFee = parseFloat(shareFee || 0).toFixed(2);
                } else if(shareFlag == 'repair') { // 维修
                    self.repairFee = parseFloat(shareFee || 0).toFixed(2);
                } else { // 其他
                    self.otherFee = parseFloat(shareFee || 0).toFixed(2);
                }
                // 回滚分摊金额
                for(let i = 0; i < receiptItemList.length; i++) {
                    let receiptItem = receiptItemList[i];
                    if(shareFlag == 'logis') { // 物流
                        receiptItem.logisPrice = 0;
                        receiptItem.logisFee = 0;
                        receiptItem.logisFee = parseFloat(receiptItem.logisFee).toFixed(2);
                    } else if(shareFlag == 'asmbl') { // 组装
                        receiptItem.asmblPrice = 0;
                        receiptItem.asmblFee = 0;
                        receiptItem.asmblFee = parseFloat(receiptItem.asmblFee).toFixed(2);
                    } else if(shareFlag == 'setup') { // 安装
                        receiptItem.setupPrice = 0;
                        receiptItem.setupFee = 0;
                        receiptItem.setupFee = parseFloat(receiptItem.setupFee).toFixed(2);
                    } else if(shareFlag == 'tear') { // 拆除
                        receiptItem.tearPrice = 0;
                        receiptItem.tearFee = 0;
                        receiptItem.tearFee = parseFloat(receiptItem.tearFee).toFixed(2);
                    } else if(shareFlag == 'toDoor') { // 上门
                        receiptItem.toDoorPrice = 0;
                        receiptItem.toDoorFee = 0;
                        receiptItem.toDoorFee = parseFloat(receiptItem.toDoorFee).toFixed(2);
                    } else if(shareFlag == 'repair') { // 维修
                        receiptItem.repairPrice = 0;
                        receiptItem.repairFee = 0;
                        receiptItem.repairFee = parseFloat(receiptItem.repairFee).toFixed(2);
                    } else { // 其他
                        receiptItem.otherPrice = 0;
                        receiptItem.otherFee = 0;
                        receiptItem.otherFee = parseFloat(receiptItem.otherFee).toFixed(2);
                    }
                    receiptItem.xtraFee = parseFloat(receiptItem.logisFee) + parseFloat(receiptItem.asmblFee) //
                        + parseFloat(receiptItem.setupFee) + parseFloat(receiptItem.tearFee) + //
                        +parseFloat(receiptItem.toDoorFee) + parseFloat(receiptItem.repairFee) + parseFloat(receiptItem.otherFee);
                }
                // 保存分摊金额
                for(let i = 0; i < shareItemList.length; i++) {
                    let item = shareItemList[i];
                    let receiptItemInfo = receiptItemList.find(function (receiptItem) {
                        return item.ukId == receiptItem.tmpNo;
                    });
                    //
                    let shareAmont = 0;
                    if(shareFlag == 'logis') { // 物流
                        receiptItemInfo.logisPrice = parseFloat(item.price);
                        receiptItemInfo.logisFee = parseFloat(receiptItemInfo.logisPrice) * receiptItemInfo.quantity;
                        receiptItemInfo.logisFee = parseFloat(receiptItemInfo.logisFee).toFixed(2);
                        self.logisFeeCalFlag = true;
                        //
                        shareAmont = receiptItemInfo.logisFee;
                    } else if(shareFlag == 'asmbl') { // 组装
                        receiptItemInfo.asmblPrice = parseFloat(item.price);
                        receiptItemInfo.asmblFee = parseFloat(receiptItemInfo.asmblPrice) * receiptItemInfo.quantity;
                        receiptItemInfo.asmblFee = parseFloat(receiptItemInfo.asmblFee).toFixed(2);
                        self.asmblFeeCalFlag = true;
                        //
                        shareAmont = receiptItemInfo.asmblFee;
                    } else if(shareFlag == 'setup') { // 安装
                        receiptItemInfo.setupPrice = parseFloat(item.price);
                        receiptItemInfo.setupFee = parseFloat(receiptItemInfo.setupPrice) * receiptItemInfo.quantity;
                        receiptItemInfo.setupFee = parseFloat(receiptItemInfo.setupFee).toFixed(2);
                        self.setupFeeCalFlag = true;
                        //
                        shareAmont = receiptItemInfo.setupFee;
                    } else if(shareFlag == 'tear') { // 拆除
                        receiptItemInfo.tearPrice = parseFloat(item.price);
                        receiptItemInfo.tearFee = parseFloat(receiptItemInfo.tearPrice) * receiptItemInfo.quantity;
                        receiptItemInfo.tearFee = parseFloat(receiptItemInfo.tearFee).toFixed(2);
                        self.tearFeeCalFlag = true;
                        //
                        shareAmont = receiptItemInfo.tearFee;
                    } else if(shareFlag == 'toDoor') { // 上门
                        receiptItemInfo.toDoorPrice = parseFloat(item.price);
                        receiptItemInfo.toDoorFee = parseFloat(receiptItemInfo.toDoorPrice) * receiptItemInfo.quantity;
                        receiptItemInfo.toDoorFee = parseFloat(receiptItemInfo.toDoorFee).toFixed(2);
                        self.toDoorFeeCalFlag = true;
                        //
                        shareAmont = receiptItemInfo.toDoorFee;
                    } else if(shareFlag == 'repair') { // 维修
                        receiptItemInfo.repairPrice = parseFloat(item.price);
                        receiptItemInfo.repairFee = parseFloat(receiptItemInfo.repairPrice) * receiptItemInfo.quantity;
                        receiptItemInfo.repairFee = parseFloat(receiptItemInfo.repairFee).toFixed(2);
                        self.repairFeeCalFlag = true;
                        //
                        shareAmont = receiptItemInfo.repairFee;
                    } else { // 其他
                        receiptItemInfo.otherPrice = parseFloat(item.price);
                        receiptItemInfo.otherFee = parseFloat(receiptItemInfo.otherPrice) * receiptItemInfo.quantity;
                        receiptItemInfo.otherFee = parseFloat(receiptItemInfo.otherFee).toFixed(2);
                        self.otherFeeCalFlag = true;
                        //
                        shareAmont = receiptItemInfo.otherFee;
                    }
                    receiptItemInfo.xtraFee = parseFloat(receiptItemInfo.logisFee) + parseFloat(receiptItemInfo.asmblFee) //
                        + parseFloat(receiptItemInfo.setupFee) + parseFloat(receiptItemInfo.tearFee) + //
                        +parseFloat(receiptItemInfo.toDoorFee) + parseFloat(receiptItemInfo.repairFee) + parseFloat(receiptItemInfo.otherFee);
                    //
                    if(receipt.manualFlag && !receipt.asmblAccOnly) {
                        receiptItemInfo.wtxPrice = (receiptItemInfo.xtraFee / receiptItemInfo.quantity).toFixed(2);   // 分摊含税价
                    } else {
                        receiptItemInfo.wtxPrice = (parseFloat(receiptItemInfo.initWtxPrice) + (receiptItemInfo.xtraFee / receiptItemInfo.quantity)).toFixed(2);   // 含税价
                    }
                    // 计算未税价
                    receiptItemInfo.ntxPrice = (parseFloat(receiptItemInfo.wtxPrice / (1 + (receiptItemInfo.taxRate * 0.01)))).toFixed(2);
                    // 计算小计（含税小计，未税小计，税额小计）
                    receiptItemInfo.wtxAmount = parseFloat(receiptItemInfo.wtxPrice * receiptItemInfo.quantity).toFixed(2);
                    receiptItemInfo.ntxAmount = parseFloat(receiptItemInfo.ntxPrice * receiptItemInfo.quantity).toFixed(2);
                    receiptItemInfo.taxAmount = parseFloat(receiptItemInfo.wtxAmount - receiptItemInfo.ntxAmount).toFixed(2);
                }
                //
                receipt.itemList = Utils.merge([], receiptItemList);
                self.receipt = Utils.merge({}, receipt);
                // 汇总金额
                self.doSumAmount();
                // 计算摊销费用总额
                self.sumXtraFeeChange(true, null);
            });
        },
        // 计算费用小计
        sumXtraFeeChange: function (calXtraFee, sumFlag) {
            let logisFee = this.logisFee || 0; // 物流费
            let asmblFee = this.asmblFee || 0; // 组装费
            let setupFee = this.setupFee || 0; // 安装费
            let tearFee = this.tearFee || 0; // 拆除费
            let toDoorFee = this.toDoorFee || 0; // 上门费
            let repairFee = this.repairFee || 0; // 维修费
            let otherFee = this.otherFee || 0; // 其他费
            if(!Utils.isMoneyStr(logisFee) || !Utils.isMoneyStr(asmblFee) || !Utils.isMoneyStr(setupFee) || !Utils.isMoneyStr(tearFee) //
                || !Utils.isMoneyStr(toDoorFee) || !Utils.isMoneyStr(repairFee) || !Utils.isMoneyStr(otherFee) || logisFee < 0 || asmblFee < 0 || setupFee < 0 //
                || tearFee < 0 || toDoorFee < 0 || repairFee < 0 || otherFee < 0) {
                MsgBox.warning('请输入正确的分摊金额');
            } else {
                this.logisFee = parseFloat(logisFee).toFixed(2);
                this.asmblFee = parseFloat(asmblFee).toFixed(2);
                this.setupFee = parseFloat(setupFee).toFixed(2);
                this.tearFee = parseFloat(tearFee).toFixed(2);
                this.toDoorFee = parseFloat(toDoorFee).toFixed(2);
                this.repairFee = parseFloat(repairFee).toFixed(2);
                this.otherFee = parseFloat(otherFee).toFixed(2);
                if(Utils.isTrue(calXtraFee)) {
                    let xtraFee = 0;
                    if(Utils.isTrue(this.logisFeeCalFlag)) { // 物流
                        xtraFee += parseFloat(logisFee);
                    }
                    if(Utils.isTrue(this.asmblFeeCalFlag)) { // 组装
                        xtraFee += parseFloat(asmblFee);
                    }
                    if(Utils.isTrue(this.setupFeeCalFlag)) { // 安装
                        xtraFee += parseFloat(setupFee);
                    }
                    if(Utils.isTrue(this.tearFeeCalFlag)) { // 拆除
                        xtraFee += parseFloat(tearFee);
                    }
                    if(Utils.isTrue(this.toDoorFeeCalFlag)) { // 上门
                        xtraFee += parseFloat(toDoorFee);
                    }
                    if(Utils.isTrue(this.repairFeeCalFlag)) { // 维修
                        xtraFee += parseFloat(repairFee);
                    }
                    if(Utils.isTrue(this.otherFeeCalFlag)) { // 其他
                        xtraFee += parseFloat(otherFee);
                    }
                    this.xtraFee = xtraFee;
                }
                if(!Utils.isNoB(sumFlag)) {
                    if(sumFlag == 'logis') { // 物流
                        this.logisFeeCalFlag = false;
                    } else if(sumFlag == 'asmbl') { // 组装
                        this.asmblFeeCalFlag = false;
                    } else if(sumFlag == 'setup') { // 安装
                        this.setupFeeCalFlag = false;
                    } else if(sumFlag == 'tear') { // 拆除
                        this.tearFeeCalFlag = false;
                    } else if(sumFlag == 'toDoor') { // 上门
                        this.toDoorFeeCalFlag = false;
                    } else if(sumFlag == 'repair') { // 维修
                        this.repairFeeCalFlag = false;
                    } else {
                        this.otherFeeCalFlag = false;
                    }
                }
            }
            this.getAmount();
        },
        // 金额汇总
        doSumAmount() {
            let receipt = this.receipt || {};
            let itemList = receipt.itemList || [];
            let purchFeeNames = this.purchFeeNames || [];
            let logisFee = 0; // 物流费
            let asmblFee = 0; // 组装费
            let setupFee = 0; // 安装费
            let tearFee = 0; // 拆除费
            let toDoorFee = 0; // 上门费
            let repairFee = 0; // 维修费
            let otherFee = 0; // 其他费
            itemList.forEach(function (item) {
                if(purchFeeNames.contains('LogisFee')) {
                    logisFee += parseFloat(item.logisFee);
                } else {
                    item.logisPrice = 0;
                    item.logisFee = 0;
                }
                if(purchFeeNames.contains('AsmblFee')) {
                    asmblFee += parseFloat(item.asmblFee);
                } else {
                    item.asmblPrice = 0;
                    item.asmblFee = 0;
                }
                if(purchFeeNames.contains('SetupFee')) {
                    setupFee += parseFloat(item.setupFee);
                } else {
                    item.setupPrice = 0;
                    item.setupFee = 0;
                }
                if(purchFeeNames.contains('TearFee')) {
                    tearFee += parseFloat(item.tearFee);
                } else {
                    item.tearPrice = 0;
                    item.tearFee = 0;
                }
                if(purchFeeNames.contains('toDoorFee')) {
                    toDoorFee += parseFloat(item.toDoorFee);
                } else {
                    item.toDoorPrice = 0;
                    item.toDoorFee = 0;
                }
                if(purchFeeNames.contains('RepairFee')) {
                    repairFee += parseFloat(item.repairFee);
                } else {
                    item.repairPrice = 0;
                    item.repairFee = 0;
                }
                if(purchFeeNames.contains('OthersFee')) {
                    otherFee += parseFloat(item.otherFee);
                } else {
                    item.otherPrice = 0;
                    item.otherFee = 0;
                }
                //
                item.xtraFee = parseFloat(item.logisFee) + parseFloat(item.asmblFee) //
                    + parseFloat(item.setupFee) + parseFloat(item.tearFee) + //
                    +parseFloat(item.toDoorFee) + parseFloat(item.repairFee) + parseFloat(item.otherFee);
            });
            //
            receipt.logisFee = parseFloat(logisFee).toFixed(2);
            receipt.asmblFee = parseFloat(asmblFee).toFixed(2);
            receipt.setupFee = parseFloat(setupFee).toFixed(2);
            receipt.tearFee = parseFloat(tearFee).toFixed(2);
            receipt.toDoorFee = parseFloat(toDoorFee).toFixed(2);
            receipt.repairFee = parseFloat(repairFee).toFixed(2);
            receipt.otherFee = parseFloat(otherFee).toFixed(2);
            receipt.xtraFee = parseFloat(logisFee) + parseFloat(asmblFee) + parseFloat(setupFee) + parseFloat(tearFee) + parseFloat(toDoorFee) + parseFloat(repairFee) + parseFloat(otherFee);
            //
            receipt.itemList = Utils.merge([], itemList);
            this.receipt = Utils.merge({}, receipt);
            this.getAmount();
        },
        // 费用小计
        getFeeItemSum: function (param) {
            const {columns, data} = param;
            const sums = [];
            columns.forEach((column, index) => {
                if(index === 0) {
                    sums[index] = '合计';
                    return;
                }
                let flag = true;
                let quantityFlag = false;
                let values = data.map(item => Number(item[column.property]));
                //
                /*if(column.property == 'quantity') {
                 values = data.map(item => Number(item['quantity']));
                 quantityFlag = true;
                 } else */
                if(column.property == 'price') {
                    values = data.map(item => Number(item['price']));
                } else if(column.property == 'amount') {
                    values = data.map(item => Number(item['amount']));
                } else {
                    flag = false;
                }
                if(flag && !values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if(quantityFlag) {
                            if(!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        } else {
                            if(!isNaN(value)) {
                                return (parseFloat(prev) + parseFloat(curr)).toFixed(2);
                            } else {
                                return parseFloat(prev).toFixed(2);
                            }
                        }
                    }, 0);
                    if(quantityFlag) {
                        sums[index];
                    } else {
                        sums[index] += ' 元';
                    }
                } else {
                    sums[index] = '-';
                }
            });
            return sums;
        },
        // 费用小计
        getDetailItemSum: function (param) {
            const {columns, data} = param;
            const sums = [];
            columns.forEach((column, index) => {
                if(index === 0) {
                    sums[index] = '合计';
                    return;
                }
                let flag = true;
                let quantityFlag = false;
                let values = data.map(item => Number(item[column.property]));
                //
                if(column.property == 'quantity') {
                    values = data.map(item => Number(item['quantity']));
                    quantityFlag = true;
                } else if(column.property == 'ntxAmount') {
                    values = data.map(item => Number(item['ntxAmount']));
                } else if(column.property == 'wtxAmount') {
                    values = data.map(item => Number(item['wtxAmount']));
                } else if(column.property == 'xtraFee') {
                    values = data.map(item => Number(item['xtraFee']));
                } else {
                    flag = false;
                }
                if(flag && !values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if(quantityFlag) {
                            if(!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        } else {
                            if(!isNaN(value)) {
                                return (parseFloat(prev) + parseFloat(curr)).toFixed(2);
                            } else {
                                return parseFloat(prev).toFixed(2);
                            }
                        }
                    }, 0);
                    if(quantityFlag) {
                        sums[index];
                    } else {
                        sums[index] += ' 元';
                    }
                } else {
                    sums[index] = '-';
                }
            });
            return sums;
        },
        invoiceTypeChange() {
            let self = this;
            let receipt = this.receipt;
            if(receipt.invoiceType == 1) {   // 增值税普通发票
                receipt.taxOffset = false;
                self.purchReceipt = Utils.merge({}, receipt);
                self.changeTaxOffset();
            } else {
                let params = {
                    invoiceType: receipt.invoiceType,
                    realComId: receipt.buyerRealComId
                };
                merchtComnApi.getTaxDeductible(params, function (result) {
                    if (result.type == 'info') {
                        receipt.taxOffset = Utils.isTrue(result.data);
                        self.receipt = Utils.merge({}, receipt);
                        self.changeTaxOffset();
                    }
                });
            }
        },
        changeTaxOffset() {
            let receipt = this.receipt;
            //
            if (receipt.taxOffset) {
                receipt.taxRate = null;
            } else {
                let fiscalTaxMarkMap = this.fiscalTaxMarkList.toMap('rate');
                if (!Utils.isNoB(fiscalTaxMarkMap['0.00'])) {
                    receipt.taxRate = '0.00';
                } else {
                    receipt.taxRate = null;
                }
            }
            this.receipt = Utils.merge({}, receipt);
            this.changeActualAmount();
        },
        getDlgResult: function () {
            let receipt = this.receipt;
            //
            if (Utils.isNoB(receipt.taxRate)) {
                MsgBox.warning("请选择税率");
                return;
            }
            if(!Utils.isTrue(this.logisFeeCalFlag) && this.logisFee != parseFloat(receipt.logisFee)) { // 物流
                MsgBox.warning('物流费分摊金额与实际分摊金额不一致，请重新计算分摊！');
                return;
            }
            if(!Utils.isTrue(this.asmblFeeCalFlag) && this.asmblFee != parseFloat(receipt.asmblFee)) { // 组装
                MsgBox.warning('组装费分摊金额与实际分摊金额不一致，请重新计算分摊！');
                return;
            }
            if(!Utils.isTrue(this.setupFeeCalFlag) && this.setupFee != parseFloat(receipt.setupFee)) { // 安装
                MsgBox.warning('安装费分摊金额与实际分摊金额不一致，请重新计算分摊！');
                return;
            }
            if(!Utils.isTrue(this.tearFeeCalFlag) && this.tearFee != parseFloat(receipt.tearFee)) { // 拆除
                MsgBox.warning('拆除费分摊金额与实际分摊金额不一致，请重新计算分摊！');
                return;
            }
            if(!Utils.isTrue(this.toDoorFeeCalFlag) && this.toDoorFee != parseFloat(receipt.toDoorFee)) { // 上门
                MsgBox.warning('上门费分摊金额与实际分摊金额不一致，请重新计算分摊！');
                return;
            }
            if(!Utils.isTrue(this.repairFeeCalFlag) && this.repairFee != parseFloat(receipt.repairFee)) { // 维修
                MsgBox.warning('维修费分摊金额与实际分摊金额不一致，请重新计算分摊！');
                return;
            }
            if(!Utils.isTrue(this.otherFeeCalFlag) && this.otherFee != parseFloat(receipt.otherFee)) { // 其他
                MsgBox.warning('其他杂费分摊金额与实际分摊金额不一致，请重新计算分摊！');
                return;
            }
            //
            let itemList = receipt.itemList;
            let maxPriceMap = this.maxPriceMap;
            for(let i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                if(item.customized) {
                    // 判断金额 是否正确
                    let initWtxPrice = item.initWtxPrice;
                    if(Utils.isNoB(initWtxPrice) || !Utils.isMoneyStr(initWtxPrice)) {
                        MsgBox.warning('【' + item.tmpNo + '】请填写正确的含税原单价(元)');
                        return;
                    } else {
                        if(!Utils.isNoB(maxPriceMap[item.id]) && maxPriceMap[item.id] < parseFloat(initWtxPrice)) {
                            MsgBox.warning('【' + item.tmpNo + '】填写的含税原单价(元)' + initWtxPrice + '已超过请购金额' + maxPriceMap[item.id]);
                            return;
                        }
                    }
                    let enterQuantity = item.enterQuantity;
                    if(Utils.isNoB(enterQuantity) || !Utils.isNaturalStr(enterQuantity, true)) {
                        MsgBox.warning('【' + item.tmpNo + '】请填写正确的入账数量');
                        return;
                    }
                }
            }
            //
            this.doSumAmount();
            //
            let result = {};
            result.type = 'info';
            result.data = this.receipt;
            return result;
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/receipt/PurchReceiptTmpAudit.vue